<template>
  <div class="ui-recent" :class="version == 'horiz'?'h-17':'h-19'">
    <div id="ui-water" v-if="waterStatus"></div>
    <!-- <NoneData tips='加载中...' :version='version' class="flex" v-else></NoneData> -->
  </div>
</template>

<script>
import fitChartSize from "@/common/js/echartFontSize.js";
import NoneData from '@/components/NoneData.vue'
export default {
  props: {
    userWaterList: {
      type: Array,
      default: []
    },
    waterStatus:{
        type:Boolean,
        default:false
    },
    isOnlineFlag:{
      type:Boolean,
      default:false
    },
    version: {
      type: String
    }
  },
  components:{
    NoneData
  },
  data() {
    return {
      dataY: [],
      dataTime: []
    };
  },
  watch: {
    userWaterList(val) {
      this.dataY = [];
      this.dataTime = [];
      val.map(item => {
        this.dataY.push(Math.round(item.totalOutFlow / 1000));
        this.dataTime.push(item.useDate);
      });
      setTimeout(()=>{
          this.initWaterEcharts();
      },500) 
    }
  },
  methods: {
    //用水趋势
    initWaterEcharts() {
      let that = this;
      if(this.waterStatus){
        this.$nextTick(()=>{
           let myChart = echarts.init(document.getElementById("ui-water"), null, {
            renderer: "svg"
          });
          let datasX = this.dataTime;
          let datasY = this.dataY;
          let option;
          if (datasX.length || datasY.length) {
            option = {
              legend: {
                selectedMode: false
              },
              // title: {
              //   text: '单位：L',
              //   x: '2%',
              //   y:'%',
              //   textStyle:{
              //     color: "#677588", 
              //     fontSize: fitChartSize(14),
              //     fontWeight:'normal'
              //   }  
              // },
              grid: {
                top: "5%",
                left: "0%",
                bottom: "5%",
                right: "5%",
                containLabel: true
              },
              xAxis: [
                {
                  type: "category",
                  boundaryGap: false,
                  axisLine: {
                    lineStyle: {
                      color: "#335971"
                    },
                    fontSize: fitChartSize(12)
                  },
                  axisTick: {
                    show: false
                  },
                  // boundaryGap: true,
                  axisLabel: {
                    color: "#335971",
                    fontSize: fitChartSize(12),
                    // rotate:45,
                    formatter: function (value) {
                      let year = new Date().getFullYear();
                      let timeArr = value.split("-");
                      let timeStr;
                      if (year == timeArr[0]) {
                        timeStr = timeArr[1] + "-" + timeArr[2];
                      } else {
                        timeStr = timeArr[0] + "\n" + timeArr[1] + "-" + timeArr[2]
                      }
                      return timeStr;
                    }
                  },
                  data: datasX
                }
              ],
              yAxis: {
                type: "value",
                nameTextStyle: {
                  color: "#04D7FB",
                  fontSize: fitChartSize(12)
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    width: 1, //这里是为了突出显示加上的
                    color: "#335971"
                  },
                  fontSize: fitChartSize(12)
                },
                axisTick: {
                  show: false
                },
                axisLabel: {
                  show: true,
                  fontSize: fitChartSize(12),
                  color: "#335971",
                  formatter: '{value}'
                },
                min: 0,
                splitLine: {
                  show: false
                }
              },
              series: [
                {
                  type: "line",
                  smooth: false,
                  showSymbol: false,//是否默认展示圆点
                  symbol: "circle",
                  symbolSize: fitChartSize(5), 
                  boundaryGap: true,
                  lineStyle: {
                    color: "#87CEFA", //折线的颜色,
                    width: 1
                  },
                  // itemStyle: {
                  //   normal: {
                  //     color: '#25A6FF'
                  //   }
                  // },
                  label: {
                    normal: {
                      position: 'top',
                      show: false,
                      textStyle: {
                        color: '#25A6FF',
                        fontSize: fitChartSize(12),
                      }
                    }
                  }, 
                  data: datasY
                }
              ]
            };
          } else {
            // option = {
            //   title: {
            //     text: this.isOnlineFlag ? "暂无数据" : '设备已离线',
            //     x: "center",
            //     y: "center",
            //     textStyle: {
            //       color: "#ccc",
            //       fontWeight: "bold",
            //       text: this.isOnlineFlag ? "暂无数据" : '设备已离线',
            //       fontFamily: "Microsoft YaHei",
            //       fontSize: fitChartSize(18)
            //     }
            //   }
            // };
          }
          myChart.clear();
          myChart.setOption(option, true);
          window.addEventListener("resize", that.changeScreen(myChart));
        })
      }
     
    },
    changeScreen(myChart){
      myChart.resize();
    }
  },
  destroyed(){  
    //  this.waterStatus = false;
     window.removeEventListener("resize",this.changeScreen)
  }
};
</script>

<style lang="scss" scoped>
.h-19 {
  height: 19.3rem;
}
.h-17 {
  // height: 15rem;
  height: 100%;
}
#ui-water {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/BrokenLine.vue